angular
    .module('dnecom')
    .directive('storeHref', ["$parse", function($parse) {
        function createUrl(store) {
            var path = Routing.generate('stores_fe_index');

            if (store && store.domain) {
                return 'http://' + store.domain + path;
            }

            if (store && store.subdomain) {
                return '//' + store.subdomain + '.' + window.ies.domain + path;
            }

            return '#';
        }

        return {
            link: function(scope, element, attrs) {
                var store = $parse(attrs.storeHref)(scope);

                element.attr('href', createUrl(store));
            }
        }
    }]);
